import { FC, SVGAttributes } from 'react';

const FilledWarning: FC<SVGAttributes<SVGElement>> = (props) => {
    return (
        <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14.6012 3.01421L22.2335 16.2602C22.4015 16.6556 22.475 16.9771 22.4959 17.311C22.5379 18.0914 22.265 18.8499 21.7296 19.4336C21.1942 20.0152 20.4698 20.3585 19.6824 20.4001H4.31287C3.98742 20.3804 3.66198 20.3065 3.35752 20.1921C1.83527 19.5782 1.10039 17.851 1.71979 16.3538L9.40455 3.00484C9.66701 2.5356 10.0659 2.13086 10.5594 1.87075C11.9871 1.07897 13.8033 1.59919 14.6012 3.01421ZM12.9114 11.7412C12.9114 12.2406 12.502 12.6578 11.9981 12.6578C11.4942 12.6578 11.0742 12.2406 11.0742 11.7412V8.79777C11.0742 8.29731 11.4942 7.89258 11.9981 7.89258C12.502 7.89258 12.9114 8.29731 12.9114 8.79777V11.7412ZM11.9981 16.217C11.4942 16.217 11.0742 15.7998 11.0742 15.3014C11.0742 14.8009 11.4942 14.3848 11.9981 14.3848C12.502 14.3848 12.9114 14.7916 12.9114 15.29C12.9114 15.7998 12.502 16.217 11.9981 16.217Z"
                fill="currentColor"
            />
        </svg>
    );
};

export default FilledWarning;
